import { Link } from "@/lib/router-compat";
import { ExternalLink } from "lucide-react";

const LegalFooter = () =>
<footer className="text-center text-xs text-muted-foreground py-6 mt-10 border-t border-border/40 space-y-3">
    <div className="flex items-center justify-center gap-4 flex-wrap">
      <Link
        to="/plugin-chatgpt"
        className="inline-flex items-center gap-2 text-muted-foreground hover:text-foreground transition-colors"
      >
        <img src="/chatgpt-logo.svg" alt="ChatGPT" className="w-4 h-4" />
        Plugin ChatGPT Juriv'IA
      </Link>
      <a
        href="https://chatgpt.com/g/g-Jv3hR7RkD-juriv-ia-version-ultra-pro-2026"
        target="_blank"
        rel="noopener noreferrer"
        className="inline-flex items-center gap-2 text-muted-foreground hover:text-foreground transition-colors"
      >
        <img src="/chatgpt-logo.svg" alt="ChatGPT" className="w-4 h-4" />
        ChatGPT Juriv'IA Ultra Pro
        <ExternalLink className="w-3 h-3" />
      </a>
    </div>
    <div className="flex items-center justify-center gap-3 flex-wrap">
      <Link to="/mentions-legales" className="hover:text-foreground transition-colors">
        Mentions légales
      </Link>
      <span>·</span>
      <Link to="/cgvu" className="hover:text-foreground transition-colors">
        CGVU
      </Link>
      <span>·</span>
      <Link to="/confidentialite" className="hover:text-foreground transition-colors">
        Politique de confidentialité
      </Link>
      <span>·</span>
      <Link to="/contact" className="hover:text-foreground transition-colors">
        Contact
      </Link>
    </div>
  </footer>;


export default LegalFooter;